import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp, stagger, viewport } from "@/lib/motion";
import { framework } from "@/lib/content";

export default function Methodology() {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="methodology-page">
      <section className="pt-36 md:pt-48 pb-16 md:pb-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <motion.div initial="hidden" animate="visible" variants={stagger}>
            <motion.div variants={fadeUp} className="text-xs uppercase tracking-[0.25em] text-[#0B1F3A]/60 mb-6">Nuestra metodología</motion.div>
            <motion.h1 variants={fadeUp} className="text-5xl md:text-7xl lg:text-8xl text-[#0B1F3A] tracking-tight leading-[0.98]">Nuestra metodología</motion.h1>
            <motion.p variants={fadeUp} className="mt-8 text-lg md:text-xl text-gray-500 max-w-2xl leading-relaxed">Una forma de trabajar clara y cercana para convertir los retos de tu empresa en mejoras reales: los cinco pasos que hay detrás de cada proyecto de Medite Group.</motion.p>
          </motion.div>
        </div>
      </section>

      <section className="border-t border-gray-100">
        {framework.map((f, i) => (
          <motion.div key={f.step} variants={stagger} initial="hidden" whileInView="visible" viewport={viewport}
            data-testid={`method-step-${f.step}`}
            className="border-b border-gray-100 group hover:bg-[#F3F4F6] transition-colors duration-500">
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-14 md:py-20 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 items-baseline">
              <motion.div variants={fadeUp} className="lg:col-span-2 text-6xl md:text-7xl font-serif text-[#0B1F3A]/15 group-hover:text-[#0B1F3A]/30 transition-colors">{f.step}</motion.div>
              <motion.h2 variants={fadeUp} className="lg:col-span-3 text-3xl md:text-4xl font-serif text-[#0B1F3A]">{f.name}</motion.h2>
              <motion.p variants={fadeUp} className="lg:col-span-6 lg:col-start-7 text-lg text-gray-600 leading-relaxed">{f.desc}</motion.p>
            </div>
          </motion.div>
        ))}
      </section>

      <section className="bg-[#0B1F3A] text-white">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <h2 className="text-4xl md:text-6xl font-serif tracking-tight leading-[1.05]">Hechos para acompañarte, no solo para aconsejar.</h2>
            <div>
              <p className="text-white/60 leading-relaxed text-lg">Nuestro trabajo no termina con una recomendación. Nos quedamos en las fases de implantación y mejora continua —trabajando junto a tu equipo y midiendo frente a los objetivos que fijamos juntos— para que tu empresa siga mejorando mucho después de poner el plan en marcha.</p>
              <Link to="/contact" data-testid="methodology-cta" className="mt-8 inline-flex items-center gap-2 rounded-full bg-white text-[#0B1F3A] px-8 py-4 font-medium hover:scale-[1.03] transition-transform">
                Solicitar un diagnóstico inicial <ArrowUpRight size={18} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
}
